import { render, staticRenderFns } from "./ColleagueModalForm.vue?vue&type=template&id=18957bfc"
import script from "./ColleagueModalForm.vue?vue&type=script&lang=js"
export * from "./ColleagueModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports